import { createFeatureSelector } from '@ngrx/store';

export const onlineMenuState = createFeatureSelector<OLO.State, OLO.State.OnlineMenu>('onlineMenu');
